/**
 * Columns front-end
 */

/**
 * Add columns count classes to cloumn blocks like before: 'has-3-columns'
 */
 const addColumnCountClasses = function() {

  const columnBlocks = document.querySelectorAll('.wp-block-columns');
  if (columnBlocks.length) {
    for (let i = 0; i < columnBlocks.length; i++) {
      const columnBlock = columnBlocks[i];
      const columns = columnBlock.querySelectorAll('.wp-block-column');
      columnBlock.classList.add('has-' + columns.length + '-columns');
    }
  }

};
addColumnCountClasses();

/**
 * Add column type
 */
const addColumnTypeClasses = function() {

  const columnBlocks = document.querySelectorAll('.wp-block-column');
  if (columnBlocks.length) {
    for (let i = 0; i < columnBlocks.length; i++) {

      const columnBlock       = columnBlocks[i];
      const children          = columnBlock.querySelectorAll(':scope > *');
      const imageBlock        = columnBlock.querySelector('.wp-block-image');
      const listBlock         = columnBlock.querySelector('.wp-block-list');
      const backgroundBlock   = columnBlock.querySelector('.wp-block-acf-background');
      const lastBlock         = columnBlock.querySelector(':scope > :last-child');

      if (children.length == 0) {
        columnBlock.classList.add('is-empty-column');
      } else if (lastBlock && lastBlock.classList.contains('wp-block-acf-button')) {
        columnBlock.classList.add('is-cta-column');
      } else if (imageBlock && children.length == 1) {
        columnBlock.classList.add('is-image-column');
      } else if (listBlock && children.length == 1) {
        columnBlock.classList.add('is-list-column');
      } else if (backgroundBlock && children.length == 1) {
        columnBlock.classList.add('is-background-column');
      } else {
        columnBlock.classList.add('is-default-column');
      }

    }
  }

  const columnsBlocks = document.querySelectorAll('.wp-block-columns');
  for (let i = 0; i < columnsBlocks.length; i++) {
    const columnsBlock = columnsBlocks[i];
    const columns = columnsBlock.querySelectorAll('.wp-block-column');

    let isCtaTypeColumns = null;

    for (let j = 0; j < columns.length; j++) {

      const column = columns[j];

      if (column.classList.contains('is-cta-column') && isCtaTypeColumns !== false) {
        isCtaTypeColumns = true;
      } else {
        isCtaTypeColumns = false;
      }

    }

    if (isCtaTypeColumns) {
      columnsBlock.classList.add('is-cta-columns');
    }

  }



};
addColumnTypeClasses();
